import encounter from "@/components/encounter/Encounter";
import encounterIndex from "@/components/encounter/Index";
import encounterMeet from "@/components/encounter/Meet";

export default {
  path: "/encounter",
  component: encounter,
  meta: {
    permission: "encounter:read|encounter:update"
  },
  children: [
    {
      path: "",
      name: "encounter-list",
      component: encounterIndex,
      meta: {
        title: "Virtual Visit List",
        permission: "encounter:read|encounter:update|encounter:manage"
      }
    },
    {
      path: "meet/:id",
      name: "encounter-meet",
      props: true,
      component: encounterMeet,
      meta: {
        title: "Virtual Visit",
        permission: "encounter:meet"
      }
    }
  ]
};
